import { alpha, Box, useMediaQuery } from "@mui/material";
import React from "react";
import { drawerWidth } from "../utils/constants";
import theme from "../utils/theme";

export default function MainLayout({ children }) {
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      sx={{
        marginLeft: isMobile ? 0 : `${drawerWidth}px`,
        paddingY: 2,
        paddingX: 2,
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        backgroundColor: theme.vars
          ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
          : alpha(theme.palette.background.default, 1),
      }}
    >
      {children}
    </Box>
  );
}
